const PILLOWCASE_CUTS_BY_SIZE = Object.freeze({
  '50x70': { narrow: '60 × 175', wide: null },
  '50x80': { narrow: '57 × 187', wide: null },
  '60x70': { narrow: '67 × 167', wide: '77 × 147' },
  '60x80': { narrow: '67 × 187', wide: '87 × 147' },
  '60x90': { narrow: '67 × 207', wide: '97 × 147' },
  '60x100': { narrow: '67 × 227', wide: '107 × 147' },
  '70x80': { narrow: '77 × 188', wide: '87 × 167' },
  '70x90': { narrow: '77 × 208', wide: '97 × 167' },
  '70x100': { narrow: '77 × 228', wide: '107 × 167' },
  '70x106': { narrow: '77 × 240', wide: '113 × 167' },
  '80x90': { narrow: '87 × 208', wide: '97 × 187' },
  '80x100': { narrow: '87 × 228', wide: '107 × 187' },
  '80x106': { narrow: '87 × 240', wide: '113 × 187' },
  '40x50': { narrow: '47 × 120', wide: '57 × 100' },
  '40x60': { narrow: '47 × 145', wide: '67 × 102' },
  '43x63': { narrow: '50 × 150', wide: '70 × 109' },
  '48x68': { narrow: '55 × 160', wide: '75 × 120' },
  '35x53': { narrow: '42 × 130', wide: null },
  '50x75': { narrow: '57 × 175', wide: null },
  '55x75': { narrow: '62 × 175', wide: null },
  '53x73': { narrow: '60 × 173', wide: null },
  '54x63': { narrow: '61 × 150', wide: '70 × 133' },
  '54x71': { narrow: '61 × 167', wide: null },
  '54x74': { narrow: '61 × 175', wide: null },
  '54x76': { narrow: '61 × 178', wide: null },
  '54x82': { narrow: '61 × 191', wide: null },
  '54x99': { narrow: '61 × 225', wide: null },
  '33x66': { narrow: '40 × 155', wide: null },
  '37x47': { narrow: '44 × 115', wide: '54 × 94' },
  '33x43': { narrow: '40 × 104', wide: '50 × 84' },
  '39x99': { narrow: '46 × 222', wide: null },
  '57x87': { narrow: '64 × 200', wide: '94 × 140' },
  '57x114': { narrow: '64 × 255', wide: null },
  '54x145': { narrow: '61 × 317', wide: null },
  '54x165': { narrow: '61 × 357', wide: null },
  '54x185': { narrow: '61 × 397', wide: null },
  '82x82': { narrow: '89 × 192', wide: null },
  '70x70': { narrow: '77 × 167', wide: null },
  '65x65': { narrow: '72 × 157', wide: null },
  '60x60': { narrow: '67 × 147', wide: null },
  '55x55': { narrow: '62 × 135', wide: null },
  '50x50': { narrow: '57 × 125', wide: null },
  '45x45': { narrow: '52 × 115', wide: null },
  '40x40': { narrow: '47 × 100', wide: null },
  '35x35': { narrow: '42 × 90', wide: null },
  '30x30': { narrow: '37 × 77', wide: null },
  '28x35': { narrow: '35 × 87', wide: '42 × 73' },
  '30x40': { narrow: '37 × 100', wide: '47 × 77' }
});

const normaliseNumber = (value) => String(Number(value));

const normaliseSize = (value) => {
  const match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*[xх×*/]\s*(\d+(?:[.,]\d+)?)/i);
  if (!match) return null;

  return `${normaliseNumber(match[1].replace(',', '.'))}x${normaliseNumber(
    match[2].replace(',', '.')
  )}`;
};

const getAttribute = (item, label) =>
  item.attributes?.find((attribute) => attribute.label === label)?.value;

const getOrderedSize = (item) => {
  const namedSize = getAttribute(item, 'Размер');
  if (namedSize) return namedSize;

  const width = getAttribute(item, 'Ширина');
  const length = getAttribute(item, 'Дължина');
  return width && length ? `${width}x${length}` : null;
};

const productDescription = (item) =>
  [
    item.productName,
    item.productCode,
    item.productSlug,
    item.productCategoryName,
    item.productSubcategoryName
  ]
    .filter(Boolean)
    .join(' ')
    .toLocaleLowerCase('bg');

const isPillowcase = (item) => productDescription(item).includes('калъфк');

const isFittedSheet = (item) => {
  const description = productDescription(item);
  return description.includes('чаршаф') && description.includes('ластик');
};

const isDuvetCover = (item) => productDescription(item).includes('плик');

const isFlatSheet = (item) =>
  productDescription(item).includes('чаршаф') && !isFittedSheet(item);

const isKidsFittedSheet = (item) => /детск|беб|kids|kdp/iu.test(productDescription(item));

const formatQuantity = (quantity) => `${quantity} ${quantity === 1 ? 'брой' : 'броя'}`;

const cutText = ({ narrow, wide }) =>
  wide
    ? `Парчето е ${narrow} см (тясна) или ${wide} см (широка)`
    : `Парчето е ${narrow} см (тясна)`;

const measurement = (value) => {
  const match = String(value ?? '').match(/\d+(?:[.,]\d+)?/);
  if (!match) return null;
  const number = Number(match[0].replace(',', '.'));
  return Number.isFinite(number) ? number : null;
};

const formattedMeasurement = (value) => {
  const rounded = Math.round(value * 100) / 100;
  return String(rounded);
};

const twoDimensionalDimensions = (item) => {
  const width = measurement(getAttribute(item, 'Ширина'));
  const length = measurement(getAttribute(item, 'Дължина'));
  if (width !== null && length !== null) return { width, length };

  const match = String(getAttribute(item, 'Размер') || '').match(
    /(\d+(?:[.,]\d+)?)\s*[xх×*/]\s*(\d+(?:[.,]\d+)?)/i
  );
  if (!match) return null;

  return { width: measurement(match[1]), length: measurement(match[2]) };
};

const formattedDimensions = (dimensions) => {
  if (!dimensions) return null;
  const values = [dimensions.width, dimensions.length, dimensions.height].filter(
    (value) => value !== undefined && value !== null
  );
  return values.length ? `${values.map(formattedMeasurement).join(' × ')} см` : null;
};

const productReference = (item, dimensions) => {
  const name = String(item.productName || '').trim();
  const code = String(item.productCode || getAttribute(item, 'Материал') || '').trim();
  const size = formattedDimensions(dimensions);
  const namedProduct = [name, size].filter(Boolean).join(' ');

  if (namedProduct && code && name !== code) return `${namedProduct} (${code})`;
  return namedProduct || code || 'Липсва продукт';
};

const productTitle = (item) => {
  const name = String(item.productName || '').trim();
  const code = String(item.productCode || getAttribute(item, 'Материал') || '').trim();

  if (name && code && name !== code) return `${name} (${code})`;
  return name || code || 'Липсва продукт';
};

const fittedSheetDimensions = (item) => {
  const width = measurement(getAttribute(item, 'Ширина'));
  const length = measurement(getAttribute(item, 'Дължина'));
  const height = measurement(getAttribute(item, 'Височина'));
  if (width !== null && length !== null && height !== null) return { width, length, height };

  const match = String(getAttribute(item, 'Размер') || '').match(
    /(\d+(?:[.,]\d+)?)\s*[xх×*/]\s*(\d+(?:[.,]\d+)?)\s*[xх×*/]\s*(\d+(?:[.,]\d+)?)/i
  );
  if (!match) return null;

  return {
    width: measurement(match[1]),
    length: measurement(match[2]),
    height: measurement(match[3])
  };
};

const fittedSheetAddition = (item) => {
  const attributes = Array.isArray(item.attributes) ? item.attributes : [];
  const values = attributes.map((attribute) => String(attribute.value || '')).join(' ');
  const explicitAddition = values.match(/\+\s*([05])\s*(?:см|cm)?/iu);
  if (explicitAddition) return Number(explicitAddition[1]);

  const additionAttribute = attributes.find((attribute) =>
    /добав|допълн|резерв/iu.test(String(attribute.label || ''))
  );
  const addition = measurement(additionAttribute?.value);
  return addition === 0 || addition === 5 ? addition : null;
};

const factoryRound = (value) => {
  const whole = Math.floor(value);
  return value - whole > 0.2000001 ? whole + 1 : whole;
};

const getPillowcaseCuts = (size) => {
  if (!size) return null;
  if (PILLOWCASE_CUTS_BY_SIZE[size]) {
    return { size, cuts: PILLOWCASE_CUTS_BY_SIZE[size] };
  }

  const [first, second] = size.split('x');
  const reversedSize = `${second}x${first}`;
  return PILLOWCASE_CUTS_BY_SIZE[reversedSize]
    ? { size: reversedSize, cuts: PILLOWCASE_CUTS_BY_SIZE[reversedSize] }
    : null;
};

const addGroupedNote = (notes, key, prefix, quantity, row) => {
  const existing = notes.get(key);
  notes.set(key, {
    prefix,
    quantity: (existing?.quantity || 0) + quantity,
    row
  });
};

const addFittedSheetNote = (item, notes, issues) => {
  const dimensions = fittedSheetDimensions(item);
  const product = productReference(item, dimensions);
  const quantity = Number(item.quantity) || 0;
  const kids = isKidsFittedSheet(item);

  if (!dimensions) {
    issues.push({
      id: item.id,
      message: `${product} — липсват ширина, дължина или височина за чаршафа с ластик.`
    });
    return;
  }

  const addition = kids ? 0 : fittedSheetAddition(item);
  if (addition === null) {
    issues.push({
      id: item.id,
      message: `${product} — не е избрано дали чаршафът с ластик е с добавени 5 см или 0 см.`
    });
    return;
  }

  const lifted = kids ? 21 : dimensions.height + 2 + addition;
  const width = factoryRound(dimensions.width * 1.06 + lifted * 2 + 6);
  const length = factoryRound(dimensions.length * 1.06 + lifted * 2 + 6);
  const childLabel = kids ? ' (детски)' : ` (добавени ${addition} см)`;
  const instructions = `Парчето е с размери ${width} × ${length} см, вдигаме ${lifted} см`;
  const prefix = `${product} — Парчето е с размери ${width} × ${length} см${childLabel}, вдигаме ${lifted} см`;
  const key = `fitted-sheet\u0000${product}\u0000${width}\u0000${length}\u0000${lifted}\u0000${kids}`;
  addGroupedNote(notes, key, prefix, quantity, {
    title: productTitle(item),
    size: `${formattedDimensions(dimensions)}${kids ? '' : childLabel}`,
    instructions
  });
};

const addTwoDimensionalNote = (item, notes, issues, type) => {
  const dimensions = twoDimensionalDimensions(item);
  const product = productReference(item, dimensions);
  const quantity = Number(item.quantity) || 0;
  const productType = type === 'duvet-cover' ? 'плика' : 'чаршафа';

  if (!dimensions) {
    issues.push({
      id: item.id,
      message: `${product} — липсват ширина или дължина за ${productType}.`
    });
    return;
  }

  const cutWidth =
    type === 'duvet-cover' ? dimensions.width * 2 + 10 : dimensions.width + 5;
  const cutLength = dimensions.length;
  const instructions = `Парчето е с размери ${formattedMeasurement(
    cutWidth
  )} × ${formattedMeasurement(cutLength)} см`;
  const prefix = `${product} — ${instructions}`;
  const key = `${type}\u0000${product}\u0000${cutWidth}\u0000${cutLength}`;
  addGroupedNote(notes, key, prefix, quantity, {
    title: productTitle(item),
    size: formattedDimensions(dimensions),
    instructions
  });
};

/**
 * Produces the factory instructions from the ordered variants. New product
 * formulas can be added here without changing the order-detail UI.
 */
const getGroupedProductionNotes = (items = []) => {
  const groupedNotes = new Map();
  const issues = [];

  items.forEach((item) => {
    if (isFittedSheet(item)) {
      addFittedSheetNote(item, groupedNotes, issues);
      return;
    }
    if (isPillowcase(item)) {
      const orderedSize = getOrderedSize(item);
      const size = normaliseSize(orderedSize);
      const formula = getPillowcaseCuts(size);
      const quantity = Number(item.quantity) || 0;
      const product = productReference(item, twoDimensionalDimensions(item));

      if (!formula) {
        issues.push({
          id: item.id,
          message: `${product} — няма зададена формула за калъфка с размер ${
            orderedSize || 'непосочен размер'
          } (${formatQuantity(quantity)}).`
        });
        return;
      }

      addGroupedNote(
        groupedNotes,
        `pillowcase\u0000${product}\u0000${formula.size}`,
        `${product} — ${cutText(formula.cuts)}`,
        quantity,
        {
          title: productTitle(item),
          size: formattedDimensions(twoDimensionalDimensions(item)),
          instructions: cutText(formula.cuts)
        }
      );
      return;
    }
    if (isDuvetCover(item)) {
      addTwoDimensionalNote(item, groupedNotes, issues, 'duvet-cover');
      return;
    }
    if (isFlatSheet(item)) addTwoDimensionalNote(item, groupedNotes, issues, 'flat-sheet');
  });

  return { groupedNotes, issues };
};

const getProductionNotes = (items = []) => {
  const { groupedNotes, issues } = getGroupedProductionNotes(items);
  return {
    notes: Array.from(groupedNotes.values()).map(({ prefix, quantity }) => ({
      text: `${prefix} — ${formatQuantity(quantity)}`
    })),
    issues
  };
};

const getProductionNoteRows = (items = []) => {
  const { groupedNotes, issues } = getGroupedProductionNotes(items);
  return {
    rows: Array.from(groupedNotes.values()).map(({ row, quantity }) => ({
      ...row,
      count: formatQuantity(quantity)
    })),
    issues
  };
};

export { getProductionNotes, getProductionNoteRows, normaliseSize };
